import {
  FETCH_SAVED_FILTERS_SUCCESS,
  FETCH_SAVED_FILTERS_FAIL,
  CREATE_SAVED_FILTER_SUCCESS,
  UPDATE_SAVED_FILTER_SUCCESS,
  DELETE_SAVED_FILTER_SUCCESS
} from '../constants';

const initialState = {
  items: [],
  error: null
};

export default function savedFiltersReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SAVED_FILTERS_SUCCESS:
      return {
        ...state,
        items: action.payload || [],
        error: null
      };
    case CREATE_SAVED_FILTER_SUCCESS:
      return {
        ...state,
        items: [...state.items, action.payload],
        error: null
      };
    case UPDATE_SAVED_FILTER_SUCCESS:
      return {
        ...state,
        items: state.items.map(filter =>
          filter.id === action.payload.id ? action.payload : filter
        ),
        error: null
      };
    case DELETE_SAVED_FILTER_SUCCESS:
      return {
        ...state,
        items: state.items.filter(filter => filter.id !== action.payload),
        error: null
      };
    case FETCH_SAVED_FILTERS_FAIL:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
}

